/**
 * MarkdownEntityStaticBadge — static fallback badge used when a markdown
 * entity tag lacks the org/id needed for live store hydration, or when
 * rendering in share-page link mode. Owns the `useMemo` so the state
 * literal stays referentially stable across re-renders.
 *
 * Lives in its own file so `entityRendering.tsx` can stay HMR-friendly
 * under the `react-refresh/only-export-components` rule.
 */

import { useMemo } from 'react';

import { EntityBadge } from '@/lib/crm/components/badges/EntityBadge';
import type { EntityBadgeState } from '@/lib/crm/components/badges/types';

export function MarkdownEntityStaticBadge({
  cleanId,
  type,
  displayName,
}: {
  cleanId: string;
  type: string;
  displayName: string;
}) {
  const state = useMemo<EntityBadgeState>(
    () => ({
      kind: 'data',
      data: { id: cleanId, entityType: type, displayName },
    }),
    [cleanId, type, displayName]
  );
  return (
    <EntityBadge
      state={state}
      variant='inline'
      interactive={false}
      className='-translate-y-px'
    />
  );
}
